import { useContext, useState, createContext } from "react";

const SharedResizingContext = createContext();

const SharedResizingProvider = ({ children }) => {
  const [currentKey, setCurrentKey] = useState(1);
  const [direction, setDirection] = useState("left");

  const updateKey = (num) => {
    const newDirection = num > currentKey ? "left" : "right";
    setDirection(newDirection);
    setCurrentKey(num);
  };

  return (
    <SharedResizingContext.Provider
      value={{ currentKey, direction, updateKey }}
    >
      {children}
    </SharedResizingContext.Provider>
  );
};

const useSharedResizing = () => {
  const context = useContext(SharedResizingContext);
  if (!context) {
    throw new Error(
      "useSharedResizing must be used within a SharedResizingProvider"
    );
  }

  return context;
};

export { SharedResizingContext, SharedResizingProvider, useSharedResizing };
